import { config } from "shared/data";

export type MenuItem = {
  name: string;
  url: string;
};

type MenuData = {
  label: string;
  links: MenuItem[];
};

export const menuMoreData: MenuData = {
  label: "MORE",
  links: [
    {
      name: "Newsletter",
      url: "/newsletters?defaultCheckedEntityIds=322743",
    },
    {
      name: "Subscription",
      url: config.rosetta.subscribeHost,
    },
  ],
};

export const menuOthersData: MenuData = {
  label: "OTHERS",
  links: [
    {
      name: "Advertise with us",
      url: "https://advertising.scmp.com/",
    },
  ],
};
